import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/a_3.svg")